import React from 'react';
import { List } from 'immutable';
import CourseViewTable from 'components/CourseViewTable';

export const EXTRA_COLUMNS = {
  GAME_COMPLETED: 'game-completed',
  GAME_COMPLETED_DATE: 'game-completed-date',
  DIAMONDS: 'diamonds',
  ACTIVITIES_COMPLETED: 'ACTIVITIES_COMPLETED',
  LAST_ACTIVITIES_DATE: 'LAST_ACTIVITIES_DATE',
};

export const Games = new List([
  {
    index: 1,
  },
  {
    index: 2,
  },
  {
    index: 3,
  },
]);

export function renderHFUsageHeader() {
  const cellItems = [
    <CourseViewTable.Cell rowSpan={2} colSpan={2} small>
      Activities
    </CourseViewTable.Cell>,
    <CourseViewTable.Cell rowSpan={3} colSpan={1}>
      Diamonds
    </CourseViewTable.Cell>,
  ];
  cellItems.push(
    Games.map((game) => (
      <CourseViewTable.Cell rowSpan={2} colSpan={2}>
        {`Game${game.index}`}
      </CourseViewTable.Cell>
    ))
  );
  return cellItems;
}

export function renderHFUsageSubHeader() {
  const cellItems = [
    <CourseViewTable.Cell colSpan={1}
        columnId={{
          column: EXTRA_COLUMNS.ACTIVITIES_COMPLETED,
          usageIndex: 0,
        }}>
      Activities Completed
    </CourseViewTable.Cell>,
    <CourseViewTable.Cell colSpan={1}
        columnId={{
          column: EXTRA_COLUMNS.LAST_ACTIVITIES_DATE,
          usageIndex: 0,
        }}>
      Last Activity Date
    </CourseViewTable.Cell>,
    <CourseViewTable.Cell style={{ display: 'none' }}
        columnId={{ column: EXTRA_COLUMNS.DIAMONDS }} />,
  ];
  cellItems.push(
    Games.reduce(
      (list, game) => [
        ...list,
        <CourseViewTable.Cell columnId={{
          usageIndex: game.index,
          column: EXTRA_COLUMNS.GAME_COMPLETED,
        }}>
          Level Completed
        </CourseViewTable.Cell>,
        <CourseViewTable.Cell columnId={{
          usageIndex: game.index,
          column: EXTRA_COLUMNS.GAME_COMPLETED_DATE,
        }}>
          Completed on
        </CourseViewTable.Cell>,
      ],
      []
    )
  );
  return cellItems;
}



// WEBPACK FOOTER //
// ./containers/Group/Homework/StudentApp/hfUsage.jsx